import { FirebaseError } from "types/firebase";

export const FIREBASE_ERROR = {
  "auth/code-expired": {
    code: "auth/code-expired",
    message: "Mã xác thực OTP đã hết hiệu lực",
  },
  "auth/too-many-requests": {
    code: "auth/too-many-requests",
    message: "Yêu cầu gửi mã xác thực OTP đã đạt tối đa, xin vui lòng thử lại sau",
  },
  "auth/invalid-verification-code": {
    code: "auth/invalid-verification-code",
    message: "Mã xác thực OTP không chính xác",
  },
  default: {
    code: "default",
    message: "Có lỗi xảy ra, xin vui lòng thử lại sau",
  },
};

function findingError(error: FirebaseError) {
  let findKey = (Object.keys(FIREBASE_ERROR).find((err) => err === error.code) ||
    "default") as keyof typeof FIREBASE_ERROR;
  let findError = FIREBASE_ERROR[findKey];
  return findError;
}

export { findingError };
